import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
export interface SchoolFiledTripModelList {
  code: number;
  message: string;
  isAnyTripAvailable:boolean;
  mdlStudentSchoolFieldTrip: MdlStudentSchoolFieldTrip[];
}
export interface MdlStudentSchoolFieldTrip {
  tripRefNo: string;
  school: string;
  primaryContact: string;
  destination: string;
  depatureDate: string;
  depatureTime: string;
  returnDate: string;
  returnTime: string;
  isLunchProvided: boolean;
  transportMode: string;

  homeContact: string;
  businessContact: string;
  emergencyContact: string;
  consentMedicalTreatments: boolean;
  consentTrip: boolean;
  consentSignature: boolean;
  acknowlegedBY: string;
  acknowlegedOn: string;
  sign: string; 
  isDisplay: boolean,
  lastDateSubmission: string,
  isSubmitted: boolean,
  isShowingFormActions: boolean
}

export interface SchoolFiledTripResponsetModel {
  code: string;
  message: string;
}

@Injectable({ providedIn: 'root' })
export class StudentFieldTripDataService {
  private modelSource = new BehaviorSubject<any>(null);
  currentModel = this.modelSource.asObservable();

  sendModel(data: any) {
    this.modelSource.next(data);
  }
}
